import {FlattenedExperimentMetricResults, StatisticallySignificant} from 'apps/experiments/src/types';
import {LocalizationStore} from 'common/i18n/store';
import {TranslationKey} from 'common/i18n';

export const formatSignificantResults = (
  i18n: LocalizationStore,
  summary: Partial<Record<StatisticallySignificant, FlattenedExperimentMetricResults[]>>,
): {
  hasSignificantResults: boolean;
  significantResults: string;
} => {
  const up = summary[StatisticallySignificant.YES_POSITIVE]?.length ?? 0;
  const down = summary[StatisticallySignificant.YES_NEGATIVE]?.length ?? 0;

  const bodyKeyPart = (count: number, key: string) => {
    if (count > 1) {
      return `-${key}-plural`;
    } else if (count === 1) {
      return `-${key}`;
    }
    return ``;
  };

  const bodyKey =
    `experiments.banner.common.significant-metrics${bodyKeyPart(up, `up`)}${bodyKeyPart(down, `down`)}` as TranslationKey;
  const bodyText = i18n.t(bodyKey, {up, down});
  return {
    hasSignificantResults: up > 0 || down > 0,
    significantResults: bodyText,
  };
};
